import React from 'react';
import { ActivityIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-16 relative" data-id="element-126">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-127">
        <div className="bg-gradient-to-r from-cyan-950/40 to-blue-950/40 border border-cyan-500/20 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-128">
          <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/xf9YcrEtCFHSFiMHXxrvbA/Untitled_design_(2).png')] opacity-5 bg-cover bg-center mix-blend-screen" data-id="element-129" />

          <ActivityIcon className="w-12 h-12 text-cyan-400 mx-auto mb-6 opacity-80" data-id="element-130" />

          <p className="text-xl md:text-2xl text-slate-200 leading-relaxed font-medium relative z-10" data-id="element-131">
            En los primeros 7 días, notarás que la presión en el pecho al
            sentarte a trabajar desaparece. No porque tengas menos trabajo, sino
            porque ahora tienes un{' '}
            <span className="text-cyan-400 font-bold" data-id="element-132">interruptor manual</span>{' '}
            para apagar el caos mental y encender la ejecución.
          </p>
        </div>
      </div>
    </section>;
}